import { createContext } from 'react';

export interface User {
  id: string;
  email: string;
  createdAt: string;
  hasSeenOnboarding?: boolean;
  systemPrompt?: string;
  maxClaudeCodeTimeout?: number;
  modelMode?: 'standard' | 'budget' | 'test' | null;
}

export interface AuthContextType {
  user: User | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkAuth: () => Promise<void>;
  markOnboardingComplete: () => void;
  updateSystemPrompt: (prompt: string) => Promise<void>;
  updateMaxTimeout: (timeoutMs: number) => Promise<void>;
  updateModelMode: (mode: 'standard' | 'budget' | 'test' | null) => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
